<template>
    <validation-observer ref="form" v-slot="{ meta }">
        <modal
            :id="modalId"
            :title="modalTitle"
            ok-title="Save"
            scrollable
            size="xl"
            :ok-disabled="!meta.valid"
            @show="setInitialData"
            @hidden="clearData"
            @ok.prevent="createdEditNote"
        >
            <validation-provider v-slot="{ errors, handleChange }" name="title" rules="required" >
                <form-input label="Title" v-model="formObject.title" :error="errors[0]" @input="handleChange" />
            </validation-provider>

            <validation-provider v-slot="{ errors, handleChange }" name="content" rules="required" >
                <form-textarea
                    label="Content"
                    rows="10"
                    v-model="formObject.content"
                    :error="errors[0]"
                    @input="handleChange"
                />
            </validation-provider>
        </modal>
    </validation-observer>
</template>

<script>
    import formInput from '../../../generic/form-input/form-input.vue';
    import FormTextarea from '../../../generic/form-textarea/form-textarea.vue';
    import Modal from '../../../generic/modal/modal.vue';

    export default {
        components: { Modal, formInput, FormTextarea },
        name: 'CreateEditNoteModal',
        props: {
            modalId: String,
            initialValues: Object,
            modalTitle: String,
        },
        data() {
            return {
                formObject: {
                    title: null,
                    content: null,
                },
            };
        },
        methods: {
            clearData() {
                this.$emit('hide');
                this.formObject = {
                    title: null,
                    content: null,
                };
            },
            async createdEditNote() {
                const { ...formObject } = this.formObject;
                this.$emit('submit', {
                    ...formObject,
                });
            },
            async setInitialData() {
                if (this.initialValues) {
                    this.formObject = {
                        id: this.initialValues.id,
                        title: this.initialValues.title,
                        content: this.initialValues.content,
                    };
                }
                this.$refs.form.setValues(this.formObject);
            },
        },
    };
</script>
